export default "__VITE_PUBLIC_ASSET__2a50d237__"